<template>
  <div class="news-detail-view-container">
    <h1 class="center test-title" v-html="detail.title || detail.userName" v-if="!transflag"></h1>
    <h1 class="center test-title" v-html="detail.zhTitle || detail.userName" v-if="transflag"></h1>
    <p v-if="detail.publisher || detail.publishTime" class="center author">
      <span>作者：</span>{{ detail.publisher }} <span style="margin-left: 20px">发布时间：</span
      >{{ detail.publishTime }}
      <span style="margin-left: 20px" v-if="isShowZh()">
        <a-switch
          size="small"
          checked-children="译文"
          un-checked-children="原文"
          v-model:checked="transflag"
        />
      </span>
    </p>
    <div v-if="detail.tweet">
      <p class="test-key">{{ detail.tweet }}</p>
    </div>
    <a-carousel autoplay v-if="detail.photos">
      <div
        class="carousel-img-container"
        v-for="(img, index) in JSON.parse(detail.photos)"
        :key="index"
      >
        <img :src="img" alt="" />
      </div>
    </a-carousel>
    <div v-if="detail.abstract">
      <p class="test-key">摘要：</p>
    </div>
    <p v-if="detail.keyword"><span class="test-key">关键字：</span></p>
    <img
      style="width: 100%"
      v-if="contentHasImg && filesInfo.length"
      :src="filesInfo[0].img"
      alt=""
    />
    <template v-for="item in contentList" v-if="!transflag && !isShowZh()">
      <p v-if="contentHasImg && filesInfo.length">{{ filesInfo[0].alt }}</p>
      <p class="center" v-if="item['img']">
        <img style="max-width: 100%" :src="item.img" :alt="item.alt" />
        <span>{{ item.alt }}</span>
      </p>
      <p v-else class="test-content" v-html="item['p']"></p>
    </template>


    <template  v-if="!transflag && !isShowZh()">
      
      <p  class="test-content" v-html="content"></p>
    </template>






    <template v-if="!transflag && isShowZh()">
      <p class="test-content" v-html="content"></p>
    </template>

    <template v-if="transflag && isShowZh()">
      <p class="test-content" v-html="zhContent"></p>
    </template>


    <div v-if="filesInfo.length">
      <p class="test-key">文件列表：</p>
      <div style="max-height: 300px; overflow-y: auto">
        <p class="test-content file-url" v-for="file in filesInfo">
          <a target="_blank" :href="file.img">
            {{ file.img }}
          </a>
        </p>
      </div>
    </div>

    <a-carousel autoplay v-if="filesInfo.length">
      <div class="carousel-img-container" v-for="(img, index) in filesInfo" :key="index">
        <img :src="img.img" alt="" />
      </div>
    </a-carousel>
  </div>
</template>

<script>
import { getNewDetailByRowKeyApi } from '@/api/DetailView/news'
import { onHttpResponseSilent } from '../../utils/request'

export default {
  data() {
    return {
      rowKey: '',
      detail: {},
      transflag: false
    }
  },
  mounted() {
    this.rowKey = this.$route.params.rowKey
    if (!this.rowKey) return

    this.getNewsDetail()
  },

  computed: {
    filesInfo() {
      if (this.detail.filesInfo) {
        let temp = JSON.parse(this.detail.filesInfo)
        let result = []
        if (temp != null && temp.length > 0) {
          temp.forEach((element) => {
            if (element != null && element != 'null' && element['unknown'] == null) {
              result.push(element)
            }
          })
        }
        return result
      } else {
        return []
      }
    },

    contentList() {
      if (this.detail.contentList) {
        let temp = JSON.parse(this.detail.contentList)
        if (Array.isArray(temp)) {
          temp = temp.map((item) => {
            if (item != null && item['p'] != null) {
              return {
                p: item['p']
                  ? item['p']
                      .replaceAll('<warn>', '<font color="red">')
                      .replaceAll('</warn>', '</font>')
                  : ''
              }
            }
            return item
          })
        }
        return temp
      } else {
        return []
      }
    },

    content() {
      var content = ''
      if(this.contentList != null && this.contentList.length > 0) {
      this.contentList.forEach((item) => {
        if (item != null && item['p'] != null) {
          content = content + item['p'] + '\n'
        }
      })
      }else{
        content = this.detail.content
      }
      return content.replace(/\n/g, '<br>')
    },

    zhContent() {
      var zhContent = ''
      if(this.detail.zhContent != null && this.detail.zhContent!= ''){
          zhContent = this.detail.zhContent 
      }
      
      return zhContent.replace(/\n/g, '<br>')
    },


    contentHasImg() {
      if (!this.detail.contentList) {
        return false
      }
      let temp = JSON.parse(this.detail.contentList)
      let pTemp = temp.filter((item) => {
        return item.hasOwnProperty('p')
      })
      if (temp.length === pTemp.length) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    getNewsDetail() {
      getNewDetailByRowKeyApi(this.rowKey)
        .then(onHttpResponseSilent)
        .then((res) => {
          this.detail = res.extra.parseFailedWebResult
          if (this.detail.title) {
            this.detail.title = this.detail.title
              ? this.detail.title
                  .replaceAll('<warn>', '<font color="red">')
                  .replaceAll('</warn>', '</font>')
              : ''
          }
        })
    },

    fixFiles(filesStr) {
      //files字段内 数组项没有引号
      if (!filesStr) return []
      filesStr = filesStr.replace(/^\[/, '').replace(/]$/, '')
      return filesStr.split(',')
    },
    isShowZh() {
      return (
        this.detail != null &&
        this.detail.zhTitle != null &&
        this.detail.zhContent != null &&
        this.detail.zhTitle != '' &&
        this.detail.zhContent != ''
      )
    }
  }
}
</script>

<style lang="less" scoped>
.news-detail-view-container {
  width: 850px;
  margin: 0 auto;
  padding-top: 120px;
  padding-bottom: 50px;

  .author {
    color: #999;
  }

  h1 {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .center {
    text-align: center;
  }

  .test-content {
    font-size: 14px;
    line-height: 30px;
    color: #666;
  }

  .test-key {
    color: #333;
    font-weight: bold;
  }

  .carousel-img-container {
    width: 100%;
    height: 350px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.05);

    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }
}
</style>
